import {useMemo} from "react";

import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {createProfileMenuItems} from "../config/profile_menu_items";

export const useProfileMenuItems = () => {
    const site = useMatchedSite();
    const {logout, preferences, standardMenuItems} = useMemo(() => createProfileMenuItems(site), [site]);

    return {
        logoutItem: logout,
        preferencesItem: preferences,
        site,
        standardMenuItems
    };
};
import {useMemo} from "react";

import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {createProfileMenuItems} from "../config/profile_menu_items";

export const useProfileMenuItems = () => {
    const site = useMatchedSite();
    const {logout, preferences, standardMenuItems} = useMemo(() => createProfileMenuItems(site), [site]);

    return {
        logoutItem: logout,
        preferencesItem: preferences,
        site,
        standardMenuItems
    };
};
